import { Status } from '../../../../../hooks/fetch.hook';

export enum SubmitSource {
  Private = 'private',
  Organization = 'organization',
}

export interface SubmitState {
  isSubmitted: boolean;
  status: Status;
  errorCode?: number;
  source: SubmitSource;
}
